import * as R from 'ramda'
import React, { Fragment, useState, useEffect } from 'react'
const { v4: uuidv4 } = require('uuid')
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import PagesTab from './pagesTab'
import G from '../../util/globalFunction'
import QuestionButton from '../shared/helpDocMark'

let __stores = {}
let __pages = []

export default props => {
    const { layout, mode, title, children, parm, passUrl } = props

    const [activePageInfo, setActivePageInfo] = useState({ activePageID: null, pageMode: 'new' })
    const { activePageID, pageMode } = activePageInfo
    const [flag, setFlag] = useState(0)

    const registPage = () => {
        const id = uuidv4()
        __pages.push({ id, title, page: children, parm, extraInfo: null, pageValue: null })
        setActivePageInfo({ activePageID: id, pageMode: 'new' })
    }

    const applyFindedPage = R.pipe(
        page => page.id,
        R.when(
            id => id !== activePageID,
            activePageID => setActivePageInfo({ activePageID, pageMode: 'find' })
        )
    )

    const handleClosePage = id => {
        const index = __pages.findIndex(page => page.id === id)
        delete __stores[activePageID]
        if (index === 0) {
            if (__pages.length === 1) {
                __pages = []
                setActivePageInfo({ activePageID: null, pageMode: 'new' })
            } else {
                const id = __pages[1].id
                __pages.shift()
                setActivePageInfo({ activePageID: id, pageMode: 'find' })
            }
        } else {
            const id = __pages[index - 1].id
            __pages.splice(index, 1)
            setActivePageInfo({ activePageID: id, pageMode: 'find' })
        }
    }

    const setFindedPage = R.pipe(
        id => __pages.find(page => page.id === id),
        ({ id }) => setActivePageInfo({ activePageID: id, pageMode: 'find' })
    )
    const handleCloseAll = () => {
        __stores = {}
        __pages = []
        setActivePageInfo({ activePageID: null, pageMode: 'new' })
    }
    const handleOpenNewTab = () =>
        typeof window !== 'undefined' &&
        window.open(
            __pages.length
                ? `${window.location.origin}${page.props.uri}`
                : `${window.location.origin}`
        )

    const pageInfo = __pages.find(page => page.id === activePageID)
    const { id, title: activeTitle, page, extraInfo, pageValue } = pageInfo || {}

    const setPageExtraInfo = extraInfo => {
        // finded를 쓰지 않으면 무한 루프 돌 가능성이 있음 아니면 child에서 useEffect에서 사용해야 함.
        const finded = __pages.find(page => page.id === activePageID)
        if (finded && !finded.extraInfo) {
            let newPages = []
            for (const info of __pages) {
                newPages.push(info.id === activePageID ? { ...info, extraInfo } : info)
            }
            //참조 정보를 갱신하면 화면 갱신
            setTimeout(() => {
                __pages = newPages
                setFlag(flag + 1)
            }, 0)
        }
    }

    const closePage = () => handleClosePage(activePageID)
    const load = () => __stores[activePageID]
    const store = pageValue => (__stores[activePageID] = pageValue)

    //passUrl또는 layout이 false일 경우 화면만 그린다.
    const child =
        passUrl || !layout
            ? children
            : page &&
              React.cloneElement(page, {
                  ...parm,
                  pageId: id,
                  pageMode,
                  pageStore: { load, store },
                  setPageExtraInfo,
                  closePage,
              })

    useEffect(() => {
        //passUrl또는 layout이 false일 경우 화면만 그린다.
        !passUrl &&
            layout &&
            R.pipe(
                () => mode !== 'new' && __pages.find(({ parm: { path } }) => path === parm.path),
                R.ifElse(R.identity, applyFindedPage, registPage)
            )()
    }, [])

    return (
        <Fragment>
            {layout ? (
                <Fragment>
                    {!(G.getMediaSize() === 'sm') && (
                        <PagesTab
                            pages={__pages}
                            currentPageId={id}
                            handleChangeChild={setFindedPage}
                            handleCloseAll={handleCloseAll}
                            handleOpenNewTab={handleOpenNewTab}
                        />
                    )}

                    {activeTitle && (
                        <div className="flex-none p-4 md:p-6 flex flex-row items-end">
                            <div className="flex-grow text-black flex flex-row items-end">
                                <h1 className="text-2xl font-semibold ">{activeTitle}</h1>
                                {extraInfo && (
                                    <h2 className="hidden md:block text-base pl-4">{extraInfo}</h2>
                                )}
                                <QuestionButton page={child} />
                            </div>
                            <div
                                className="hidden md:block flex-none flex items-center cursor-pointer"
                                onClick={e => {
                                    e.preventDefault()
                                    handleClosePage(activePageID)
                                }}
                            >
                                <span className="text-sm mx-2 ">현재창 닫기</span>
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </div>
                        </div>
                    )}
                    <div className="flex flex-col overflow-auto">{child}</div>
                </Fragment>
            ) : (
                <Fragment>{children}</Fragment>
            )}
        </Fragment>
    )
}
